import { NavLink } from "react-router-dom";

const LINKS = [["/developers", "Overview", true], ["/developers/apps", "Applications"], ["/developers/docs", "Documentation"], ["/developers/usage", "Usage"], ["/developers/explorer", "API explorer"]];

export function DevNav() {
  return (
    <nav aria-label="Developer portal" className="mb-8 flex flex-wrap gap-2 border-b border-amber-900/30 pb-4" data-testid="dev-portal-nav">
      {LINKS.map(([to, label, end]) => (
        <NavLink key={to} to={to} end={end} data-testid={`dev-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
          className={({ isActive }) => `rounded-full border px-4 py-1.5 font-mono text-xs uppercase tracking-wider transition-colors ${isActive ? "border-amber-500 bg-amber-500/10 text-amber-200" : "border-[#2A3447] text-slate-400 hover:border-amber-700 hover:text-amber-200"}`}>
          {label}
        </NavLink>
      ))}
    </nav>
  );
}

export const STATUS_TONE = { draft: "text-slate-400 border-slate-600", active: "text-emerald-300 border-emerald-600/60", suspended: "text-copper-300 border-orange-600/60", revoked: "text-red-300 border-red-600/60", paused: "text-copper-300 border-orange-600/60", disabled: "text-slate-400 border-slate-600", succeeded: "text-emerald-300 border-emerald-600/60", pending: "text-amber-300 border-amber-600/60", dead: "text-red-300 border-red-600/60", skipped: "text-slate-400 border-slate-600" };

export function StatusPill({ status, testid }) {
  return <span className={`rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${STATUS_TONE[status] || "text-slate-400 border-slate-600"}`} data-testid={testid}>{status}</span>;
}

export function Code({ children }) {
  return <pre className="overflow-x-auto rounded-md border border-[#2A3447] bg-[#0B0E14] p-4 font-mono text-xs leading-relaxed text-amber-100/90">{children}</pre>;
}
